import nQueryObject from "./nQueryObject.js";

export default class nQueryDocument extends nQueryObject {
	constructor(objects) {
		super(objects);
	}
}
